export default "<div class=\"check-list\">\n  <ng-content></ng-content>\n</div>\n"